import { scoreManagerABI } from '@celo/abis';
import { getContract } from 'viem';
import { resolveAddress } from './registry.js';
export async function getScoreManagerContract(clients) {
    return getContract({
        address: await resolveAddress(clients.public, 'ScoreManager'),
        abi: scoreManagerABI,
        client: clients,
    });
}
